module.exports = __webpack_public_path__ + "static/img/gift@2x (6).1e29f450.png";